import Image from "next/image"
import Link from "next/link"
import Divider from "components/DynamicComponent/atoms/Divider"
import richText from "utilities/richText"
import cn from "classnames"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function AwardCard({ blok }) {
  return (
    <div className="bg-white p-7 pt-2 shadow-[0px_2px_6px_0px_rgba(0,0,0,0.05)]">
      <div>
        <div className="flex items-center justify-center">
          <div className={cn({ "py-6": !blok.logo.filename })}>
            {getStoryblokLink(blok.link) ? (
              <Link href={getStoryblokLink(blok.link)} target="_blank" alt={blok.logo.alt} title={blok.logo.title}>
                <Image
                  className="w-full"
                  src={blok?.logo.filename ? blok?.logo?.filename : "/assets/placeholder.png"}
                  alt={blok?.logo.alt ? blok.logo.alt : blok.name}
                  title={blok?.logo.title}
                  width={400}
                  height={400}
                />
              </Link>
            ) : (
              <Image
                className="w-full"
                src={blok?.logo.filename ? blok?.logo?.filename : "/assets/placeholder.png"}
                alt={blok?.logo.alt}
                title={blok?.logo.title}
                width={400}
                height={400}
              />
            )}
          </div>
        </div>
        <Divider />
        <div className="pt-7">
          <h3 className="text-m2">{blok.name}</h3>
          <div className="pt-2 prose">{richText(blok.content)}</div>
        </div>
      </div>
    </div>
  )
}
